<template>
    <div class="container mx-auto mt-24 p-8">
        <div class="flex items-end justify-between">
            <h2 class="text-6xl font-bold text-camaq-700">{{ $t('Featured job opportunities') }}</h2>
            <InertiaLink
                :href="$page.props.locale == 'fr' ? `/emplois` : `/job-opportunities`"
                class="font-bold uppercase text-camaq-700 hover:underline"
            >
                {{ $t('View all job opportunities') }}
            </InertiaLink>
        </div>

        <div class="mt-10 grid gap-5 lg:grid-cols-3">
            <div v-for="offer in props.offers" class="flex h-[430px] flex-col rounded-lg border border-[#667085] bg-[#F2F4F7] p-6">
                <img :src="offer.company.logo" alt="" class="h-20 w-full rounded-lg bg-white object-contain p-2" />

                <div class="mt-4 flex items-center space-x-2 text-[#667085]">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-map-pin"
                        width="21"
                        height="21"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <path d="M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                        <path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
                    </svg>
                    <span>{{ offer.city }}</span>
                </div>

                <p class="mt-10 font-bold uppercase tracking-wider">{{ offer.company.name }}</p>

                <h2 class="text-2xl font-bold uppercase leading-tight tracking-wider text-camaq-700">
                    <InertiaLink
                        :href="$page.props.locale == 'fr' ? `/emplois/${offer.slug}` : `/job-opportunities/${offer.slug}`"
                        class="line-clamp-3"
                    >
                        {{ offer.title }}
                    </InertiaLink>
                </h2>

                <InertiaLink
                    :href="$page.props.locale == 'fr' ? `/emplois/${offer.slug}` : `/job-opportunities/${offer.slug}`"
                    class="mt-auto block w-full rounded bg-camaq-700 p-3 text-center text-sm font-bold uppercase tracking-wider text-white hover:bg-opacity-90"
                    style="box-shadow: 0px 4px 20px 0px rgba(30, 64, 175, 0.05)"
                >
                    {{ $t('Apply now') }}
                </InertiaLink>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        offers: Array,
    });
</script>
